import { useRef, useEffect } from 'react';
import { useChatStore } from '../../store/chatStore';
import  MessageBubble  from './MessageBubble';
import ThinkingIndicator from './ThinkingIndicator';
import  WelcomeScreen from './WelcomeScreen';

function ChatArea({ onSend, onFocusInput }) {
  const { messages, activeRole, isThinking } = useChatStore();
  const roleMessages = messages[activeRole];
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [roleMessages.length, isThinking]);

  if (roleMessages.length === 0 && !isThinking) {
    return (
      <WelcomeScreen
        onSend={onSend}
        onFocusInput={onFocusInput}
      />
    );
  }

  return (
    <div
      className="flex-1 overflow-y-auto nitor-scrollbar px-5 md:px-7 py-5"
      style={{ background: '#0a1628' }}
    >
      {roleMessages.map((msg) => (
        <MessageBubble
          key={msg.id}
          message={msg}
          onFollowUp={onSend}
        />
      ))}
      {isThinking && <ThinkingIndicator />}
      <div ref={bottomRef} />
    </div>
  );
}

export default ChatArea;